<template>
    <div class="form-group--border">
        <div v-if="item" class="scrollable-content">
            <div class="pmpk-view">
                <div class="row">
                    <div class="form-group col-4">
                        <label class="control-label">Идентификатор</label>
                        <ComponentInput v-bind:modelValue="item.externalId" disabled="true"/>
                    </div>
                    <div class="form-group col-4">
                        <label class="control-label">Дата формирования</label>
                        <ComponentInput v-bind:modelValue="$momentFormat(item.formed, 'DD.MM.YYYY')" disabled="true"/>
                    </div>
                    <div class="form-group col-4">
                        <label class="control-label">Печатная версия</label>
                        <file-upload width="100%" :entity="item" prop-name="file" label="Нет файла" readonly="true"/>
                    </div>
                </div>
                <h5>Реквизиты документа</h5>
                <div class="row">
                    <div class="form-group col-4">
                        <label class="control-label">Номер</label>
                        <ComponentInput v-bind:modelValue="item.docNum" disabled="true"/>
                    </div>
                    <div class="form-group col-4">
                        <label class="control-label">Дата</label>
                        <ComponentInput v-bind:modelValue="$momentFormat(item.docDate, 'DD.MM.YYYY')" disabled="true"/>
                    </div>
                    <div class="form-group col-4">
                        <label class="control-label">Срок действия</label>
                        <ComponentInput v-bind:modelValue="$momentFormat(item.docValidTo, 'DD.MM.YYYY')" disabled="true"/>
                    </div>
                </div>
            </div>
        </div>
        <div>
            <div class="float-right d-flex align-items-center mt-4">
                <button-component type="button" kind="secondary" class="btn" v-on:click="close">Закрыть</button-component>
            </div>
        </div>
    </div>
</template>

<script>
  import ButtonComponent from "@/common/ui/ButtonComponent";
  import Api from "../api/ipra";
  import ComponentInput from "@/common/components/ComponentInput";
  import FileUpload from "@/common/components/FileUpload";
  export default {
    name: "IpraModalCard",
    components: {FileUpload, ComponentInput, ButtonComponent},
    props: {
      id: {
        type: Number
      }
    },
    data() {
      return {
        item: null
      };
    },
    created() {
      this.loadCard();
    },
    methods: {
      loadCard() {
        Api.find(this.id)
          .then((response) => {
            this.item = response.data;
          });
      },
      close() {
        this.$emit('close');
      }
    }
  }
</script>

<style lang="scss" scoped>
    .scrollable-content {
        overflow-y: auto;
        max-height: calc(100vh - 250px);
    }
    .pmpk-view {
        max-width: 98%;
    }
</style>